import BaseApi, { FetchMethodType } from 'api/BaseApi';

export interface IPandaDocConnectionStatus {
  connected: boolean;
}

export interface IPandaDocEmbeddedSigningParams {
  contactEmail: string;
}

export interface IPandaDocEmbeddedSigningData {
  sessionId?: string;
  waitingForOthers?: boolean;
}

export interface IPandaDocApi {
  getConnectionStatus(): Promise<IPandaDocConnectionStatus>;
  createEmbeddedSigningData(applicationDisplayId: string): Promise<IPandaDocEmbeddedSigningData>;
}

export default class PandaDocRestApi extends BaseApi implements IPandaDocApi {
  public getConnectionStatus(): Promise<IPandaDocConnectionStatus> {
    return this.fetch<IPandaDocConnectionStatus>('/panda-doc/connection-status');
  }

  public createEmbeddedSigningData(applicationDisplayId: string): Promise<IPandaDocEmbeddedSigningData> {
    return this.fetch<IPandaDocEmbeddedSigningData>('/panda-doc/create-embedded-signing-data', {
      method: FetchMethodType.POST,
      body: {
        applicationDisplayId,
      },
    });
  }
}
